import { ArrowRightNeutral, OpenIcon } from 'components/Icons';
import * as S from './styles';
import { InvoiceStatus } from 'components/InvoiceStatus';
import { useCustomUtilsHistory } from 'services/react-router-custom-history';

export type PlanProps = {
  title: string;
  description?: string;
  subTitle?: string;
  link?: string;
  type?: 'default' | 'myProducts';
  icon?: React.ReactNode;
  status?: string;
  planType?: string;
  id?: number;
  setIsOpenDrawer?: () => void;
};

export const Plan = ({
  title,
  description,
  subTitle,
  status,
  planType,
  type = 'default',
  icon,
  link,
  id,
  setIsOpenDrawer,
}: PlanProps) => {
  const history = useCustomUtilsHistory();
  const handleNavigate = () => {
    type === 'myProducts'
      ? history.push(`${link}`)
      : id === 7
      ? setIsOpenDrawer && setIsOpenDrawer()
      : window.open(`${link}`, '_blank');
  };
  return (
    <S.Wrapper
      backgroundColor={'transparent'}
      borderColor={'#D8D8D8'}
      border
      onClick={handleNavigate}
      type={type}
    >
      <S.ContentWrapper>
        <S.HeaderWrapper>
          <S.Title>
            {icon && icon}
            <S.TitleText type={type}>{title}</S.TitleText>
          </S.Title>
          {icon  && id !== 7 && <OpenIcon />}
          {id === 7 && <ArrowRightNeutral />}
        </S.HeaderWrapper>
        {type === 'myProducts' && (
          <>
            <S.SubTitle>{subTitle}</S.SubTitle>
            <S.Title>
              <InvoiceStatus
                text={`${status}`}
                status={status === 'ativo' ? 'paga' : 'vencida'}
                colortText="#1A1A1A"
                fontWeight="500"
              />
              {planType && (
                <InvoiceStatus
                  text={`${planType}`}
                  status={'venda'}
                  colortText="#1A1A1A"
                  fontWeight="500"
                />
              )}
            </S.Title>
          </>
        )}
        {type !== 'myProducts' && <S.Description>{description}</S.Description>}
      </S.ContentWrapper>
      {type === 'myProducts' && <ArrowRightNeutral />}
    </S.Wrapper>
  );
};
